import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { ButtonProps } from "@mui/material";

import { theme } from "../mui-customs/Theme";
import { IconProps } from "../types/utils";
import Typography from "./Typography";

interface SquareIconButtonProps extends LoadingButtonProps {
  title: string;
  Icon: React.ComponentType<IconProps>;
}

const SquareIconButton = ({ title, Icon, ...props }: SquareIconButtonProps) => {
  return (
    <LoadingButton
      variant="contained"
      sx={{
        borderRadius: "16px",
        display: "inline-flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        height: { md: "90px", xs: "80px" },
        width: { md: "90px", xs: "80px" },
        backgroundColor: theme.brand1[500],
        textTransform: "none",
      }}
      {...props}
    >
      <Icon dimension={20} />
      <Typography
        variant="small2"
        sx={{ color: `${theme.whiteBg.WBG1} !important` }}
      >
        {title}
      </Typography>
    </LoadingButton>
  );
};

export default SquareIconButton;
